import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const RateContext = createContext(null);

export const RateProvider = ({ children }) => {
  const [rate, setRate] = useState({ mad_to_eur: 0.093, eur_to_mad: 10.75, mad_to_gbp: 0.079, interest_rate: 4.5, source: "..." });

  useEffect(() => {
    api.get("/exchange-rate").then(({ data }) => setRate(data)).catch(() => {});
  }, []);

  return <RateContext.Provider value={rate}>{children}</RateContext.Provider>;
};

export const useRate = () => {
  const ctx = useContext(RateContext);
  return ctx || { mad_to_eur: 0.093, eur_to_mad: 10.75, mad_to_gbp: 0.079, interest_rate: 4.5 };
};
